<template>
  <div>
    <!-- 基本信息-入住需求-->
    <roomBasic  :ruleForm="formData" :modify="modify" :orderConfirm="orderConfirm" v-show="tabLabel===1" class="room-Type" ref="roomBasic" :isHotelInquiry="isHotelInquiry"></roomBasic>
    <!--填写完成-->
    <div class="statusBar">
      <ul v-if="tabLabel>1">
          <li class="complete" v-if="tabLabel>1" @click="tabLabel=1">
              <div> 入住信息</div>
              <div class="text-success">填写完成<i class="el-icon-arrow-right ml-2"></i></div>
          </li>
      </ul>
      <ul class="fillin">
          <li class="complete" v-if="tabLabel===3||tabLabel===4" @click="switchNeeds(2)" :class="{'w-100':!modify}">
              <div> 用房需求</div>
              <div :class="formData.room_need.length>0?'text-success':'text-danger'">{{formData.room_need.length>0?'填写完成':'未填写' }}<i class="el-icon-arrow-right ml-2"></i></div>
          </li>
          <li class="complete" v-if="tabLabel===2||tabLabel===4" @click="switchTabMeetings" :class="{'w-100':!modify}">
              <div> 会议需求<span class="text-ris">(非必填·有会议需求可去添加)</span></div>
              <div :class="formData.meeting_need.length>0?'text-success':'text-danger'">{{formData.meeting_need.length>0?'填写完成':'未填写' }}<i class="el-icon-arrow-right ml-2"></i></div>
          </li>
          <li class="complete" v-if="(tabLabel===2||tabLabel===3)&&modify" @click="switchNeeds(4)" >
              <div> 附加需求<span class="text-ris">(非必填·会场费、餐饮、住宿费用)</span></div>
              <div :class="formData.add_need.length>0?'text-success':'text-danger'">{{formData.add_need.length>0?'填写完成':'未填写' }}<i class="el-icon-arrow-right ml-2"></i></div>
          </li>
      </ul>
    </div>
    <!--用房需求-->
    <roomType v-show="tabLabel===2" class="room-Type mt-3" :room_need_clone="formData.room_need" :modify="modify" ref="roomType"></roomType>
    <!--用房-优惠房-->
    <roomType v-show="tabLabel===2" class="room-Type mt-3" :room_need_clone="formData.discount_need" :modify="modify" :discount="true" ref="discount" v-if="modify"></roomType>
    <!--会议需求-->
    <meetingType v-show="tabLabel===3" class="room-Type mt-4" :meeting_need="formData.meeting_need" :modify="modify"  ref="meetingType"></meetingType>
    <!--其他需求-->
    <other v-show="tabLabel===4" :add_need="formData.add_need" class="room-Type mt-3" ref="other"></other>
    <div class="room-type-footer mt-4 room-Type room-bottom">
      <template v-if="tabLabel===1">
        <el-button type="primary" @click="roomBasicBottom()">下一步、填写用房需求</el-button>
      </template>
      <template v-if="tabLabel>1">
        <!-- <el-button @click="back()">返回修改</el-button> -->
        <el-button type="primary" :disabled="buttonsShow" @click="submitForm()">确认发布订单</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import roomBasic from './Components/roomBasic.vue'                 //基本信息-入住需求
import roomType from './Components/roomType.vue'                   //用房需求
import meetingType from './Components/meetingType.vue'             //会议需求
import other from './Components/other.vue'                         //其他需求
import Temp from '@/views/Admin/FinancialManage/FinancialStats/EchartStat/temp.vue'
export default {
  name: 'Room',
  components: {roomBasic, roomType, meetingType,other, Temp},
  mounted() {},
  props: {
    //订单详情
    orderDetail: {
      type: Object,
      default: () => {}
    },
    //是否修改订单
    modify: {
      type: Boolean,
      default: false
    },
    //是否询价酒店
    isHotelInquiry: {
      type: Boolean,
      default: false
    },
    //是否确认订单
    orderConfirm: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      orderInfo:{},                                    //修改原生数据
      //表单数据
      formData: {
        order_type: 1,                            //订单类型：1住宿订单、2纯会议订单、
        team_type: 1,                             //团队类型：1旅游团、2会议团
        need_mode:1,                             //多晚入住
        title: '',                                //团号标题
        province:'',                              //目的地省份
        city:'',                                  //目的地城市
        district:[],                                //目的地区县
        star:[],                                  //酒店星级
        date_in: '',                              //入住日期
        date_out:'',                              //离店日期
        num:'',                                   //人数
        breakfast:'',                             //早餐需求
        room_need: [],                            //房型需求
        meeting_need: [],                         //会议需求
        discount_need:[],                         //优惠房需求
        other:[],                                 //其他需求
        eatery:'',                                //餐饮需求
        remark:'',                                //备注
        add_need:[],                              //附加需求
      },                  
      tabLabel:1,                                 //1：基本信息-入住需求 2：用房需求 3：会议需求、4：其他需求
      returnvalue:false,                          //记录每个每次返回值
      buttonsShow:true,                          //是否显示确认发布订单按钮

    };
  },
  computed: {
      ...mapGetters(['storeInfo']),
  },
  watch: {
    orderDetail: {
      handler(newVal, oldVal) {
        this.initModifyOrder(newVal);
      },
      deep: true
    },
    
  },
  created() {
  },
  mounted() {

    //
  },
  methods: {
    //下一步、切换房型需求
    nextStep(e) {
      //已填写完基本信息切换房型需求
      if(this.tabLabel===1){
        this.tabLabel = 2;
        // this.formData=e;
      }
      //如果房型需求为空生成房型需求
      // if(this.formData.room_need.length===0){
      //   this.getRoomType(e);
      // }
      // console.log(e);
    },
    //入住日期、人数、自动生成房型需求
    getRoomType(e){
      if(e.room_need.length!=0){
        return;
      };
      let room_need = [];
      const oneDay = 24 * 60 * 60 * 1000;         // 一天的毫秒数
      let date_in = e.date_in[0];                 //开始时间
      let date_out = e.date_in[1];                //结束时间
      let num = e.num;                            //入住人数
      //循环开始-结束时间戳、默认双床房、人数/2向上取整为房间数量
      while (date_in <date_out) {
        room_need.push({
          date:date_in,
          offer_info:[
            { 
              type:2,
              room_num:Math.ceil( num / 2 ),
              offer_price:'',
              offer_id:'',
              offer_title:'',
              breakfast:this.orderConfirm?e.breakfast:''
            },
          ]}
          );
        date_in += oneDay;

      }
      //生成房型需求
      this.formData.room_need = room_need;
      this.buttonsShow = true;
    },
    //切换会议需求
    switchTabMeetings(){
      //判断当前房型是全部填完
      let isSubmit = this.$refs.roomType.submitForm('back');
      //最少一个用房需求添加
      if(isSubmit.room_need.length==0){
        return this.$message.error('请添加一个用房需求');
      }
      if(isSubmit){
        this.tabLabel = 3;
      }
    },
    //切换其他需求
    switchNeeds(i){
      //判断当前房型是全部填完
      let isSubmit = this.isSubmitForm();
      if(isSubmit){
        this.tabLabel = i;
      }
    },
    //*****************修改订单方法*****************//
    //修改订单初始化
    initModifyOrder(res){
      res=JSON.parse(JSON.stringify(res));       //防止连带
      let Value=this.$_Object.getSecondObjIntersectionValues(this.formData,res);       //只获取交集对象
      Value = this.$_Object.convertCommaValueToArray(Value, false, true);              //带','转为数组
      //酒店修改默认早餐提供
      //需要转数字的字段数组
      const numKeys = ['order_type', 'city', 'province', 'breakfast']
      numKeys.forEach(key => Value[key] = Number(Value[key]));
      //如果是多晚入住时间毫秒转换秒
    // 批量赋值
    res.room_need_arr = this.transformDateArr(res.room_need_arr)
    res.discount_need = this.transformDateArr(res.discount_need)
    res.meeting_need_arr = this.transformDateArr(res.meeting_need_arr)
      Value={
        ...this.formData,
        ...Value,
        order_type:1,                                                          //订单类型
        district:this.$_Array.commaStrToArray(Value.district)||[],             //区转为数组、方便确认单
        star:this.$_Array.commaStrToArray(Value.star)||[],                     //星级转为数组、方便确认单
        other:this.$_Array.commaStrToArray(Value.other)||[],                   //其他需求转为数组、方便确认单
        room_need:res.room_need_arr,                                           //房型需求
        meeting_need:res.meeting_need_arr,                                     //会议需求
        breakfast_type:res.breakfast_type,                                     //早餐提供
        add_need:res.add_need_arr.list||[],                                    //附加需求
      } 
      this.formData = Value;      //赋值给表单数据
      this.orderInfo=JSON.parse(JSON.stringify(Value));       //防止连带-修改原生数据
    },
    // 公共处理：提取list并把date秒转毫秒
    transformDateArr(target) {
      // 不存在直接返回原对象兜底
      if (!target || !target.list) return target
      // 遍历转换date
      return target.list.map(item => ({
        ...item,
        date: item.date * 1000
      }))
    },
    //*****************确认订单方法*****************//
    //调用基本信息确认方法
    async roomBasicBottom(){
      let {isSubmit,formData} = await this.$refs.roomBasic.submitForm();       //调用基本信息确认方法
      this.formData = {...this.formData,...formData};
      if(isSubmit){
        this.getRoomType(formData);
        this.buttonsShow = false;
        this.tabLabel = 2;
      }
    },
    //确认订单
    submitForm(){
      let isSubmit = this.isSubmitForm();
      console.log(isSubmit);
      let discount_need=[]
      //最少一个用房需求添加
      if(this.tabLabel===2&&isSubmit.room_need.length==0){
        return this.$message.error('请添加一个用房需求');
      }
      //修改时多判断一个优惠房
      if(this.modify){
        // 对比原始数据和当前数据是否有变化
        const isModify = this.$_Array.isEqual(this.orderInfo, this.formData);
        if(!isModify){
          this.$message({
            message: '您未修改任何内容',
            type: 'warning'
          });
          return;
        }
        discount_need=this.$refs.discount.submitForm();
        if(!discount_need) return
      }
      //确认订单弹出确认框
      if(isSubmit){
        this.formData = {...this.formData,...isSubmit,
          discount_need:discount_need.room_need||[],
        };
        this.$emit('submitForm',this.formData);
      }
    },
    //判断当前需求是否填写完整
    isSubmitForm(){
      if(this.tabLabel===2){
        return this.$refs.roomType.submitForm();
      }
      if(this.tabLabel===3){
        return this.$refs.meetingType.submitForm();
      }
      if(this.tabLabel===4){
        return this.$refs.other.submitForm();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
    .statusBar{
      background-color: #fff;
      box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
      margin-top: 16px;
      border-radius: 6px;
    }

    .complete{
        width: 94%;
        display: flex;
        justify-content: space-between;
        padding: 20px 3%;
        cursor: pointer;
    }
    .room-Type{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        width: 94%;
        padding: 3%;
        border-radius: 6px;
    }
    .text-ris{
      color: #999;
      margin-left: 12px;
    }
    .fillin{
      display: flex;
      justify-content:space-between;
      border-top: 1px solid var(--smtc-color-bg-border-gray);
      li:nth-child(1){
        border-right: 1px solid var(--smtc-color-bg-border-gray);
      }
    }
    .room-bottom{
      width: 96%;
      padding: 2%;
      position: sticky;
      bottom: 0;
      left: 0 ;
      z-index: 9;
    }
</style>